module.exports = __webpack_public_path__ + "static/media/ad.06bfc0ce.svg";